export const GET_PRESIGNED_URL_REQUEST = "GET_PRESIGNED_URL_REQUEST";
export const GET_PRESIGNED_URL_SUCCESS = "GET_PRESIGNED_URL_SUCCESS";
export const GET_PRESIGNED_URL_FAIL = "GET_PRESIGNED_URL_FAIL";

export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAIL = "UPLOAD_FILE_FAIL";

export const DELETE_FILE_REQUEST = "DELETE_FILE_REQUEST";
export const DELETE_FILE_SUCCESS = "DELETE_FILE_SUCCESS";
export const DELETE_FILE_FAIL = "DELETE_FILE_FAIL";

export const RESET_S3_UPLOAD_STATE = "RESET_S3_UPLOAD_STATE";
